import { useState } from "react";
import { Download, Search } from "lucide-react";
import { useApi } from "../lib/api";
import { exportCsv } from "../lib/format";
import { SectionHead, DataBadge, ErrorState } from "../components/common";
import TokenTable from "../components/TokenTable";
import usePageMeta from "../lib/usePageMeta";

const SORTS = [["volume", "Highest Volume"], ["mcap", "Market Cap"], ["holders", "Most Holders"], ["price", "Price"], ["name", "Name A-Z"]];

export default function Tokens() {
  usePageMeta("Tokens", "Discover and screen every token on Robinhood Chain with live prices, volume, market cap and holders.");
  const [q, setQ] = useState("");
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("volume");
  const [stocksOnly, setStocksOnly] = useState(false);
  const { data, loading } = useApi(`/tokens?sort=${sort}${query ? `&q=${encodeURIComponent(query)}` : ""}${stocksOnly ? "&stocks_only=true" : ""}`);

  return (
    <div className="space-y-3">
      <SectionHead title="Tokens on Robinhood Chain" badge={<DataBadge live={data?.live ?? true} />} right={
        <button data-testid="export-csv-button" onClick={() => exportCsv(data?.items || [], "feather_tokens.csv")} className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 border border-[#262626] rounded-sm hover:border-[#3F3F46] transition-colors"><Download size={13} /> CSV</button>
      } />

      <div className="flex flex-wrap gap-2 items-center">
        <form onSubmit={(e) => { e.preventDefault(); setQuery(q.trim()); }} className="flex items-center gap-2 bg-[#121212] border border-[#262626] rounded-sm px-2.5 h-8 focus-within:border-[#059669] transition-colors w-72">
          <Search size={14} className="text-[#6B7280]" />
          <input data-testid="token-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, symbol or address…"
            className="bg-transparent outline-none text-[13px] w-full placeholder:text-[#4B5563]" />
        </form>
        <select data-testid="sort-select" value={sort} onChange={(e) => setSort(e.target.value)}
          className="bg-[#121212] border border-[#262626] rounded-sm px-2 py-1.5 text-[13px] outline-none">
          {SORTS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <label className="flex items-center gap-1.5 text-xs text-[#9CA3AF]">
          <input data-testid="stocks-only-checkbox" type="checkbox" checked={stocksOnly} onChange={(e) => setStocksOnly(e.target.checked)} className="accent-[#059669]" /> Tokenized stocks only
        </label>
        {query && <button data-testid="clear-search-button" onClick={() => { setQ(""); setQuery(""); }} className="text-xs text-[#6B7280] hover:text-[#F3F4F6]">Clear "{query}"</button>}
      </div>

      {data && !data.live && <ErrorState />}

      <div className="t-card">
        <div className="px-3 py-2 border-b border-[#262626] text-xs text-[#6B7280]" data-testid="results-count">
          {data ? `${data.items.length} tokens${data.next_page_params ? " (more available — refine search)" : ""}` : "Loading live token data…"}
        </div>
        <TokenTable tokens={data?.items} loading={loading} />
      </div>
    </div>
  );
}
